import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Input } from "ui/Form";
import { useDebouncedCallback } from "use-debounce";

type Props = {
  isDisabled?: boolean;
  placeholder?: string;
};

const Search = ({ isDisabled, placeholder }: Props) => {
  const location = useLocation();
  const history = useHistory();

  const [searchValue, setSearchValue] = useState(
    new URLSearchParams(location.search).get("search") ?? "",
  );

  const onDebouncedValueChange = useDebouncedCallback((value) => {
    const params = new URLSearchParams(location.search);

    if (!value) {
      params.delete("search");
    } else {
      params.set("search", value);
    }

    history.push(`${location.pathname}?${params.toString()}`);
  }, 500);

  const onValueChange = (value: string) => {
    setSearchValue(value);
    onDebouncedValueChange(value);
  };

  return (
    <Input
      name="search"
      className="w-[400px] h-[32px] mb-16"
      placeholder={placeholder}
      disabled={isDisabled}
      onChange={(e) => onValueChange(e.target.value)}
      endAdornment={<SearchIcon color="action" />}
      value={searchValue}
    />
  );
};

export default Search;
